module.exports = __webpack_public_path__ + "static/assets/fa121178a0dc748c56257f39987f0540.svg";